/* prettier-ignore */

import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';
import { ChatBubbleComponent } from 'src/chatbot/components/chatBubble/chatBubble.component';
import { DataChatService } from '../../service/dataChat.service';
import { ChatInputFormComponent } from 'src/chatbot/components/chatInputForm/chatInputForm.component';
import { RecommendedMessagesComponent } from 'src/chatbot/components/recommendedMessages/recommendedMessages/recommendedMessages.component';
import { ScrollService } from 'src/chatbot/service/scrollContainer.service';
import { SaveChatFormComponent } from 'src/chatbot/components/saveChatForm/saveChatForm/saveChatForm.component';
import { TypingDotsComponent } from 'src/chatbot/components/typingDots/typingDots/typingDots.component';
import { ChatHeaderComponent } from 'src/chatbot/components/chatHeader/chatHeader.component';
import { ToolsService } from 'src/app/services';
import { auditTime, fromEvent, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'chat-view',
  standalone: true,
  imports: [
    CommonModule,

    ChatBubbleComponent,
    ChatInputFormComponent,
    RecommendedMessagesComponent,
    SaveChatFormComponent,
    TypingDotsComponent,
    ChatHeaderComponent,
  ],
  templateUrl: './chatView.html',
  styleUrls: ['./chatView.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatViewComponent {
  @ViewChild('scrollContainer') private scrollContainer?: ElementRef;

  public scrollService = inject(ScrollService);
  public dataChat = inject(DataChatService);
  private tools = inject(ToolsService);
  private destroy$ = new Subject<void>();

  ngAfterViewInit(): void {
    this.scrollService.setScrollContainer(this.scrollContainer?.nativeElement);

    if (!this.tools.isWebApp())
      return;
    
    fromEvent<CustomEvent>(window as any, 'android:ime')
      .pipe(auditTime(50), takeUntil(this.destroy$))
      .subscribe((ev) => {
        this.scrollToBottom()
    });
  }

  scrollToBottom(): void {
    if (this.scrollContainer) {
      try {
        this.scrollContainer.nativeElement.scrollTop =
          this.scrollContainer.nativeElement.scrollHeight;
      } catch (err) {}
    }
  }

  ngOnDestroy(): void {
    this.destroy$?.next();
    this.destroy$?.complete();
  }
}
